//React
import React from "react";

//UI
import { Select } from "../../Common/Input/index";

//Processing
import { BILLING_METHOD } from "../../../utils/onboarding-helper";

const billngMethodValues = Object.values(BILLING_METHOD);

const billngMethodOptions = billngMethodValues.map((billingMethod) => {
  return {
    value: billingMethod,
    label: billingMethod,
  };
});

const BillingMethodSelect = (props) => {
  const { onChange, value } = props;

  return (
    <Select
      value={value}
      onChange={onChange}
      showSearch
      options={billngMethodOptions}
      className="full-width"
      placeholder="Billing Method"
      optionFilterProp="children"
      filterOption={(input, option) =>
        (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
      }
    />
  );
};

export default BillingMethodSelect;
